<section id="contact-support-popup">
    <div class="modal-header" fxLayoutAlign="end center">
        <mat-icon (click)="onClose()" class="close-icon cursor-pointer">close</mat-icon>
    </div>
    <div class="modal-body">
        <app-contact></app-contact>
    </div>
</section>